// extracted by mini-css-extract-plugin
export default {"danger":"UserRegistrationForm_danger__nCU5B"};